import { Controller } from '@hotwired/stimulus'
import Chart from 'chart.js/auto'

export default class extends Controller {
  static targets = ['reviewRate', 'autoConfirmRate', 'outOfRangeChart']

  static values = {
    url: String
  }

  charts = {}

  connect() {
    this.loadData()
  }

  disconnect() {
    Object.values(this.charts).forEach((chart) => chart.destroy())
    this.charts = {}
  }

  async loadData() {
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin'
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      this.renderStats(data)
    } catch (error) {
      console.error('Failed to load quality data:', error)
    }
  }

  renderStats(data) {
    // Review rate
    if (this.hasReviewRateTarget) {
      this.reviewRateTarget.textContent = `${data.review_rate}%`
    }

    // Auto-confirm rate
    if (this.hasAutoConfirmRateTarget) {
      this.autoConfirmRateTarget.textContent = `${data.auto_confirm_rate}%`
    }

    // Out-of-range distribution
    if (this.hasOutOfRangeChartTarget && data.out_of_range_distribution) {
      this.renderOutOfRangeChart(data.out_of_range_distribution)
    }
  }

  renderOutOfRangeChart(distribution) {
    const canvas = document.createElement('canvas')
    this.outOfRangeChartTarget.innerHTML = ''
    this.outOfRangeChartTarget.appendChild(canvas)

    const labels = Object.keys(distribution).map((k) => `${k} markers`)
    const values = Object.values(distribution)

    this.charts.outOfRange = new Chart(canvas, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Tests',
            data: values,
            backgroundColor: ['#10B981', '#3B82F6', '#F59E0B', '#EF4444'],
            borderWidth: 0,
            borderRadius: 2
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        plugins: {
          legend: { display: false }
        },
        scales: {
          x: {
            beginAtZero: true,
            grid: { color: '#E2E8F0' },
            ticks: { font: { size: 10 } }
          },
          y: {
            grid: { display: false },
            ticks: { font: { size: 10 } }
          }
        }
      }
    })
  }
}
